export default "__VITE_ASSET__C9o8aLK4__"